import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "g-row g-row--align_center g-row--appearance_spaced" }
const _hoisted_2 = { class: "global-error" }
const _hoisted_3 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_4 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_5 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_6 = {
  key: 0,
  class: "g-cell g-cols g-cols--narrow"
}
const _hoisted_7 = { class: "ds-inliner ds-inliner--size_lg" }
const _hoisted_8 = { class: "ds-inliner__body" }
const _hoisted_9 = { class: "g-cell g-cols g-cols--10" }
const _hoisted_10 = { class: "g-row g-row--appearance_nowrap g-row--align_center sk-space_pl sk-space_pl--0" }
const _hoisted_11 = {
  key: 0,
  class: "g-cell g-cols g-cols--narrow"
}
const _hoisted_12 = { class: "ds-inliner ds-inliner--size_xl" }
const _hoisted_13 = { class: "ds-inliner__body" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--10 ellipsis-content ellipsis-content--1" }
const _hoisted_15 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_16 = { class: "g-cell g-cols g-cols--12 g-cols--6-lg" }
const _hoisted_17 = {
  key: 0,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_18 = { class: "g-cell g-cols g-cols--12 g-cols--auto-md sk-space_mt sk-space_mt--6 sk-space_mt--10-lg" }
const _hoisted_19 = { class: "g-row g-row--align_center g-row--appearance_spaced" }
const _hoisted_20 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_21 = { class: "g-cell g-cols g-cols--auto" }
const _hoisted_22 = { class: "ds-caption ds-caption--size_2xs ds-caption--appearance_medium ds-caption--appearance_start" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_26 = { class: "global-error" }
const _hoisted_27 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-md sk-space_mt sk-space_mt--6 sk-space_mt--10-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_DInput = _resolveComponent("DInput")!
  const _component_DSelect = _resolveComponent("DSelect")!
  const _component_DPhone = _resolveComponent("DPhone")!
  const _component_DTextarea = _resolveComponent("DTextarea")!
  const _component_d_control_recaptcha = _resolveComponent("d-control-recaptcha")!
  const _component_VeeField = _resolveComponent("VeeField")!
  const _component_ControlButton = _resolveComponent("ControlButton")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, {
    onSubmit: $setup.request,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, validate, values, setFieldError, isSubmitting }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(message), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DInput, {
            name: "name",
            size: ['md'],
            "input-label": $setup.$t('Your name'),
            modelValue: $setup.form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event)),
            rules: "required"
          }, null, 8, ["input-label", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DSelect, {
            name: "country",
            size: ['md'],
            "input-label": $setup.$t('Country'),
            modelValue: $setup.form.country,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.country) = $event)),
            rules: "required",
            labelBy: "title",
            trackBy: "id",
            "internal-search": false,
            searchable: true,
            loading: $setup.countriesLoading,
            options: $setup.countriesList,
            onSearchChange: e => $setup.countriesSearch(e),
            onGetItems: $setup.countriesGet.bind(null)
          }, {
            option: _withCtx(({ option }) => [
              _createElementVNode("div", _hoisted_5, [
                (option?.code2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2 || '').toLowerCase()}`])
                          }, null, 2)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                ])
              ])
            ]),
            singleLabel: _withCtx(({ option }) => [
              _createElementVNode("div", _hoisted_10, [
                (option?.code2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["fi fis flag-wrap", `fi-${(option.code2).toLowerCase()}`])
                          }, null, 2)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, _toDisplayString(" " + option.title), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["input-label", "modelValue", "loading", "options", "onSearchChange", "onGetItems"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_DInput, {
            name: "email",
            size: ['md'],
            "input-label": $setup.$t('Email address'),
            modelValue: $setup.form.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.email) = $event)),
            rules: "required|email"
          }, null, 8, ["input-label", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(), _createBlock(_component_DPhone, {
            key: $setup.keyForReloadPhone,
            name: "phone",
            size: ['md'],
            "input-label": $setup.$t('Phone'),
            modelValue: $setup.form.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phone) = $event)),
            "default-country-code": $setup.currentCountryCode,
            rules: `required|realPhone:${$setup.form.phone}`
          }, null, 8, ["input-label", "modelValue", "default-country-code", "rules"]))
        ]),
        (!$setup.props.hideMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_DTextarea, {
                class: "is-textarea",
                name: "message",
                size: ['md'],
                "input-label": $setup.$t('Your message'),
                modelValue: $setup.form.message,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.message) = $event)),
                rows: "5",
                rules: "max:1000"
              }, null, 8, ["input-label", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_d_control_recaptcha, {
          class: "control-descriptor--clear",
          modelValue: $setup.form.captcha,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.captcha) = $event)),
          ref: "captchaRef",
          onVerify: _cache[6] || (_cache[6] = ($event: any) => ($setup.saveCaptcha($event)))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_VeeField, {
                name: "agreeTerms",
                rules: "required",
                id: "agreeTerms",
                type: "checkbox",
                "checked-value": true,
                "unchecked-value": false,
                value: true,
                modelValue: $setup.form.agreeTerms,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.agreeTerms) = $event)),
                as: "control-checkbox"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, [
                _createTextVNode(_toDisplayString($setup.$t('By checking this box, I consent to the processing of my personal data in accordance with the')) + " ", 1),
                _createElementVNode("a", {
                  class: "sk-link sk-link--appearance_underline sk-link--size_xs sk-link--inline",
                  href: $setup.userAgreement,
                  target: "_blank"
                }, _toDisplayString($setup.$t('Terms of Service')), 9, _hoisted_23),
                _createTextVNode(" " + _toDisplayString($setup.$t('and')) + " ", 1),
                _createElementVNode("a", {
                  class: "sk-link sk-link--appearance_underline sk-link--size_xs sk-link--inline",
                  href: $setup.privacyPolicy,
                  target: "_blank"
                }, _toDisplayString($setup.$t('Privacy Policy')), 9, _hoisted_24)
              ])
            ]),
            _createVNode(_component_VeeError, { name: "agreeTerms" }, {
              default: _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(message), 1)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_ControlButton, {
            styling: 'dark',
            disabled: isSubmitting || $setup.isLoad,
            view: ['full-till-md'],
            type: "submit",
            "start-icon": "i-send",
            onClick: _withModifiers(($event: any) => ($setup.validateForm(validate, $setup.getCaptcha, setFieldError)), ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.$t('Send')), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 512))
}